"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mock_job_1 = require("../jobs/mock-job");
var mock_condensed_trip_1 = require("../trips/mock-condensed-trip");
var mock_condensed_punch_card_1 = require("../punch-cards/mock-condensed-punch-card");
var mock_organization_1 = require("../organizations/mock-organization");
exports.EXPENSE = {
    id: '00000000-0000-0000-0000-000000000001',
    number: '1234',
    amount: '1234.56',
    expenseAmount: '1234.45',
    surchargeAmount: '100.00',
    tripsAmount: '0.0',
    tripsExpenseAmount: '0.0',
    punchcardsAmount: '0.0',
    punchcardsExpenseAmount: '0.0',
    subtotal: '0.0',
    ownerOrganization: mock_organization_1.ORGANIZATION,
    customerOrganization: mock_organization_1.ORGANIZATION,
    job: mock_job_1.JOB,
    sendable: true,
    sent: false,
    draft: true,
    sentTime: '2017-05-03T08:00:00Z',
    sentBy: '',
    sentTrips: [mock_condensed_trip_1.CONDENSEDTRIP, mock_condensed_trip_1.CONDENSEDTRIP],
    sentPunchCards: [mock_condensed_punch_card_1.CONDENSEDPUNCHCARD, mock_condensed_punch_card_1.CONDENSEDPUNCHCARD],
    billFromContactEmail: 'invoice\@goruckit.com',
    billFromCcEmails: 'diego\@goruckit.com, adriana\@goruckit.me',
    billFromAddress: 'Ruckit',
    billToContactEmail: 'johndoe\@brbrokergroup.biz',
    billToCcEmails: '',
    billToAddress: 'B\&R Broker Group LLC',
    createdAt: '2017-05-03T08:00:00Z',
    expenseUrl: '',
    startDate: '2017-04-03T08:00:00Z',
    endDate: '2017-05-03T08:00:00Z',
    remittanceInfo: 'Remittance Info',
    earliestBillableItemTime: '',
    latestBillableItemTime: '',
    expensePeriod: 'April 3, 2017 - May 3, 2017',
    title: 'Expense Draft',
    administrativeStatus: 'draft',
    displayableStatus: false,
    shortTitle: 'Expense Draft ',
    pdf: '',
    html: '',
    paymentType: 'Check',
    url: null,
    filterOptions: null
};
